import script from "./AssignIntervenantModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssignIntervenantModal.vue?vue&type=script&setup=true&lang=ts"

import "./AssignIntervenantModal.vue?vue&type=style&index=0&id=010bd3e8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-010bd3e8"]])

export default __exports__